import './TeamsRatesList.sass';

import React from 'react';

import NumberUtils from '../../lib/NumberUtils';
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '../../utilities/localStorage';
import Spinner from '../Spinner/Spinner';
import TeamRatesRow from './TeamRatesRow';

class TeamRatesList extends React.Component {
  constructor(props) {
    super(props);

    this.state = { search: '' };
  }

  reloadUsers = (search = this.state.search, page = this.state.page) => {
    this.setState({ search: search || '', page: page || 1 });
    this.props.reloadUsers(search, page);
  };

  changePage = (page) => {
    this.setState({ page });
    this.reloadUsers(null, page);
  };

  renderRole = (rate) => (
    <TeamRatesRow
      key={NumberUtils.obtainUniqueKey()}
      rate={rate}
      selected={
        this.props.selectedRate?.id || this.props.selectedRate?.id === 0
          ? this.props.selectedRate.id === rate.id
          : false
      }
      onRateClick={
        this.props.viewQuals ? this.props.onQualsClick : this.props.onRateClick
      }
      viewQuals={this.props.viewQuals}
      booksPage={this.props.booksPage}
      loadingBooks={this.props.loadingBooks}
    />
  );

  componentWillUnmount() {
    setLocalStorageItem('rateSearch', this.state.search);
  }

  componentWillMount() {
    const storedSearch = getLocalStorageItem('rateSearch');
    if (
      storedSearch &&
      this.state.search !== storedSearch &&
      this.props.booksPage
    ) {
      this.setState({ search: storedSearch });
    }
  }

  renderRoles = (rates) => {
    if (rates) {
      return rates.map((rate) => this.renderRole(rate));
    }
  };

  renderLoading = () => <Spinner />;

  renderTable = (loading, rates) => {
    if (loading) {
      return this.renderLoading();
    }
    return <div>{this.renderRoles(rates)}</div>;
  };

  renderBookPageHeader = (onPlusClick, onSearch, searchValue) => (
    <div className="booksPageHeaderContainer">
      <div className="flexItemsTitlePlus">
        <div className="booksPageTitle">AFSCs</div>
        {onPlusClick && (
          <i className="fa fa-plus fa-lg mt-1 addRate" onClick={onPlusClick} />
        )}
        {onSearch && (
          <div
            className="searchInput"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <input
              id="input"
              className="form-control"
              value={searchValue}
              onChange={onSearch}
            />
            {searchValue ? (
              <i
                onClick={() => this.clearSearchInput()}
                className="fa fa-close fa-lg"
              />
            ) : (
              <i className="fa fa-search fa-lg" />
            )}
          </div>
        )}
      </div>
      <div className="lineBooksPage" />
    </div>
  );

  clearSearchInput = () => {
    this.setState({ search: '' });
  };

  onSearch = (event) => {
    this.setState({ search: event.target.value });
  };

  getSearchRates = () => {
    let { rates } = this.props;
    if (this.state.search !== '') {
      const search = this.state.search.toLowerCase();
      rates = rates.filter((r) => {
        if (r.id !== 0) {
          return (
            r.name.toLowerCase().includes(search) ||
            r.shortname.toLowerCase().includes(search)
          );
        }
        return null;
      });
    }
    rates = rates.sort((a, b) => a.shortname - b.shortname);
    return rates;
  };

  render() {
    const { loading, rates, toggleList, booksPage, viewQuals } = this.props;
    const searchAction = this.onSearch;
    const editableRates = rates.slice();
    let newEditableRates = this.getSearchRates(editableRates);
    if (!booksPage) {
      newEditableRates = rates;
    }
    return (
      <div>
        <div className="rolesListItems">
          {!booksPage && (
            <div className="titleContainer">
              <div
                className={booksPage ? 'title booksPageTitle' : 'ratesTitle'}
                onClick={() => toggleList()}
              >
                AFSCs
              </div>
              {/* <div className="qualsTitle" onClick={() => toggleList()}>
                Quals
              </div> */}
            </div>
          )}
          {!booksPage && (
            <div className={viewQuals ? 'line lineQuals' : 'line'} />
          )}
          {booksPage &&
            this.renderBookPageHeader(
              this.onPlusClick,
              searchAction,
              this.state.search,
              this.props.clearSearchInput,
            )}
        </div>
        <div className="animated fadeIn rolesTable">
          {newEditableRates.length > 0 ? (
            this.renderTable(loading, newEditableRates)
          ) : (
            <div>No AFSCs</div>
          )}
        </div>
      </div>
    );
  }
}

export default TeamRatesList;
